
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["list", "icon"]

    connect() {
        this.open = true
    }

    toggle() {
        this.open = !this.open
        this.listTarget.classList.toggle("hidden", !this.open)
        if (this.open) {
            this.iconTarget.classList.remove("rotate-180")
        } else {
            this.iconTarget.classList.add("rotate-180")
        }
    }
}
